import { AxiosError } from 'axios';
import { axios } from 'config/axios';
import { ErrorData, ErrorDataViolation } from 'types/embedded/error';

export type PresetItemPayload = {
  id?: string;
  amount: string;
  badge?: string;
  description?: string;
};

export type PresetServerError = {
  message: string;
  violations: ErrorDataViolation[];
};

export const updatePresetItems = (
  presetId: string,
  direction: 'payment_items' | 'payout_items',
  presetItems: PresetItemPayload[],
) =>
  axios
    .patch(
      `presets/${presetId}/${direction}`,
      { presetItems },
      { headers: { 'content-type': 'application/merge-patch+json' } },
    )
    .catch((error: AxiosError<ErrorData>) => {
      const data = error.response?.data;
      const violations: ErrorDataViolation[] = [
        ...(data?.violations ?? []),
        ...(data?.errors ?? []).map(({ source, title, code }) => ({
          propertyPath: source?.parameter ?? '',
          message: title,
          code,
        })),
      ];
      return Promise.reject<PresetServerError>({
        message: data?.['hydra:description'] || error.message,
        violations,
      });
    });
